const Content = [
  'Vi går igenom uppgifterna om din bil och kommer kontakta dig, vanligtvis inom 24 timmar. Därefter går vi tillsammans igenom alla detaljer och väljer du att gå vidare med försäljningen så hjälper vi dig med allt pappersarbete.',
  'Är du intresserad av att köpa en ny bil så kan vi hjälpa dig med det också.',
];

const WhatHappensNow = `
<div class="waykevaluation-stack waykevaluation-stack--4">
  <h4 class="waykevaluation-heading waykevaluation-heading--4">Vad händer nu?</h4>
  <div class="waykevaluation-content">
    ${Content.map((c) => `<p class="waykevaluation-content__p">${c}</p>`).join('')}
  </div>
</div>
`;

export default WhatHappensNow;
